<template>
  <div class="container-fluid">
    <!-- Funds Tables -->
    <div class="mt-4 row" id="element-to-print">
      <div
        class="container-fluid table-main remove-styles2 remove-border responsiveness"
      >
        <div v-if="bookType == 'pdf'" class="row d-none">
          <table
            id="table"
            class="table remove-styles mt-0 col-md-12 table-hover table-header-area"
          >
            <thead>
              <tr>
                <th>
                  <div class="row">
                    <div class="col-md-12 d-flex justify-content-between">
                      <div>
                        <div class="s-20 fw-500">
                          Income Statement by Fund (Profit & Loss)
                        </div>
                        <div class="s-18 font-weight-600">
                          {{ tenantDisplayName }}
                        </div>
                        <div class="s-18 fw-500">
                          <span class="mr-1"> Date Range: </span>
                          <span>
                            {{ formatDate(startDate) }}
                            to {{ formatDate(endDate) }}
                          </span>
                        </div>
                      </div>
                      <div>
                        <img
                          :src="churchLogo"
                          v-if="churchLogo"
                          class="link-image mr-2"
                          alt=""
                        />
                        <img
                          src="../../../assets/dashboardlinks/churchcloud.png"
                          v-else
                          class="link-image mr-2"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
          </table>
        </div>

        <table
          id="table"
          class="table remove-styles mt-0 table-hover table-header-area"
        >
          <thead class="table-header-ar">
            <tr class="font-weight-bold">
              <th>ACCOUNTS</th>
              <th class="text-right"></th>
              <th class="text-right text-dak s-14">
                {{ formatDate(startDate) }} <br />
                to {{ formatDate(endDate) }}
              </th>
            </tr>
          </thead>
        </table>
      </div>
      <div
        v-for="(fundData, fundName, index) in groupedByFund"
        :key="fundName"
        :class="{ 'mt-4': index > 0 }"
        class="container-fluild border rounded mt-2 table-main remove-styles2 remove-border responsiveness"
      >
        <div class="s-18 font-weight-600 col-md-12 pl-2 mt-2 py-3 text-dak">
          {{ fundName }}
        </div>

        <table id="table" class="table remove-styles mt-0 table-hover table-header-area">
          <tbody>
            <!-- Income Row -->
            <tr class="table-header-area-main fw-500 s-14">
              <td>Account</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td class="text-blue-400 fw-500 s-14">Income</td>
              <td></td>
              <td class="text-right">
                {{ currentUser.currencySymbol }}
                {{ formatAmount(fundTotals[fundName]?.income || 0) }}
              </td>
            </tr>

            <!-- Expense Row -->
            <tr>
              <td class="text-blue-400 fw-500 s-14">Expense</td>
              <td></td>
              <td class="text-right">
                {{ currentUser.currencySymbol }}
                {{ formatAmount(fundTotals[fundName]?.expense || 0) }}
              </td>
            </tr>

            <!-- Net Balance -->
            <tr class="table-header-ar">
              <td class="s-14 text-dak font-weight-bold">Fund balance</td>
              <td></td>
              <td
                class="text-right text-dak s-14 font-weight-bold"
                :style="{
                  color:
                    (fundTotals[fundName]?.income || 0) -
                      (fundTotals[fundName]?.expense || 0) <
                    0
                      ? 'red'
                      : '#00000',
                }"
              >
                {{ currentUser.currencySymbol }}
                {{
                  formatAmount(
                    (fundTotals[fundName]?.income || 0) -
                      (fundTotals[fundName]?.expense || 0)
                  )
                }}
              </td>
            </tr>
            <tr
              class="table-header-area-main"
              v-if="index === Object.keys(groupedByFund).length - 1"
            >
              <td class="s-14 text-dak font-weight-bold">Net Balance</td>
              <td></td>
              <td class="text-right text-dak font-weight-bold s-14">
                {{ currentUser.currencySymbol }}
                {{ formatAmount(netBalanceAllFunds) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, watchEffect, ref, watch, nextTick } from "vue";
import { useStore } from "vuex";
import axios from "@/gateway/backendapi";
import exportService from "../../../services/exportFile/exportserjs";
import dateFormatter from "../../../services/dates/dateformatter";

const store = useStore();

const props = defineProps({
  startDate: {
    type: String,
    default: "",
  },
  endDate: {
    type: String,
    default: "",
  },
  fileHeaderToExport: {
    type: Array,
    required: true,
  },
  fileToExport: {
    type: Array,
    required: true,
  },
  fileName: {
    type: String,
    default: "",
  },
  bookType: {
    type: String,
    default: "",
  },
  incomeStatementSummaryData: {
    type: Object,
    default: () => ({}),
  },
});
const formatDate = (date) => {
  return dateFormatter.monthDayYear(date);
};

const tenantData = ref({});
const churchLogo = ref("");

const emit = defineEmits(["download-complete"]); // Add this line

// Watch for changes in bookType prop
watch(
  () => props.bookType,
  async (newVal, oldVal) => {
    if (!newVal || newVal === oldVal) return;

    try {
      if (newVal === "pdf") await nextTick();

      exportService.downLoadExcel(
        newVal,
        document.getElementById("element-to-print"),
        props.fileName,
        props.fileHeaderToExport,
        props.fileToExport
      );

      emit("download-complete", true);
    } catch (error) {
      emit("download-complete", false);
    }
  },
  { immediate: true } // Changed to true to catch all changes
);

const getChurchProfile = async () => {
  try {
    let { data } = await axios.get(
      `/GetChurchProfileById?tenantId=${getUser.value.tenantId}`
    );
    console.log(data);
    churchLogo.value = data.returnObject.logo;
  } catch (err) {
    console.error(err);
  }
};

const getUser = computed(() => {
  if (
    !store.getters.currentUser ||
    (store.getters.currentUser &&
      Object.keys(store.getters.currentUser).length == 0)
  )
    return "";
  return store.getters.currentUser;
});

watchEffect(() => {
  if (getUser.value) {
    tenantData.value = getUser.value;
    getChurchProfile();
  }
});
const tenantDisplayName = computed(() => {
  if (!tenantData.value.churchName) return "";
  const name =
    tenantData.value.churchName.length < 20
      ? tenantData.value.churchName
      : `${tenantData.value.churchName.slice(0, 20)}...`;
  return name;
});

const currentUser = computed(() => {
  if (store && Object.keys(store.getters.currentUser).length > 0)
    return store.getters.currentUser;
  return "";
});

const groupedByFund = computed(() => {
  const funds = {};

  props.incomeStatementSummaryData.transactions?.forEach((transaction) => {
    const fundName = transaction.fund || "Uncategorized";
    const category = transaction.accountCategory;

    if (!funds[fundName]) {
      funds[fundName] = {};
    }

    if (!funds[fundName][category]) {
      funds[fundName][category] = [];
    }

    funds[fundName][category].push(transaction);
  });

  return funds;
});

// Calculate totals for each fund
const fundTotals = computed(() => {
  const totals = {};

  for (const fundName in groupedByFund.value) {
    totals[fundName] = {
      income:
        groupedByFund.value[fundName].Income?.reduce(
          (sum, item) => sum + Math.abs(item.amount),
          0
        ) || 0,
      expense:
        groupedByFund.value[fundName].Expense?.reduce(
          (sum, item) => sum + Math.abs(item.amount),
          0
        ) || 0,
    };
  }

  return totals;
});

const netBalanceAllFunds = computed(() => {
  let totalIncome = 0;
  let totalExpense = 0;

  // Sum income and expenses from all funds
  for (const fundName in groupedByFund.value) {
    totalIncome += fundTotals.value[fundName]?.income || 0;
    totalExpense += fundTotals.value[fundName]?.expense || 0;
  }

  return totalIncome - totalExpense;
});

// Format Amount
const formatAmount = (amount) => {
  if (typeof amount !== "number") return "0.00";
  return amount.toLocaleString("en-NG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
</script>

<style scoped>
.table th,
.table td {
  border-top: none;
}
.active {
  background: #ffffff;
  color: #08162e;
  font-weight: 700;
  width: 81px;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  /* padding: 15px 0; */
}
.bg-secondary {
  background-color: #f8f9fa !important;
}
button.el-button {
  height: 36px !important;
  width: 139px !important;
  padding: 13px 24px !important;
  font-size: 13px !important;
}
.table-main {
  width: 100% !important;
  box-shadow: 0 0.063rem 0.25rem #02172e45 !important;
  /* border: 0.063rem solid #dde2e6 !important; */
  /* border-radius: 30px !important; */
  text-align: left !important;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem !important;
}

.remove-styles {
  border: none !important;
  box-shadow: none !important;
  border-bottom: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.remove-styles2 {
  padding-right: 0;
  padding-left: 0;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
table tbody tr,
table thead tr {
  border-bottom: 1px solid rgba(0, 0, 1, 0.2);
}
table tbody tr:first-child {
  border-bottom: none !important;
}
table tbody tr:last-child {
  border-bottom: none !important;
}

.remove-border {
  box-shadow: none !important;
}
.table {
  width: 100% !important;
  box-shadow: none !important;
  border: none !important;
  text-align: left;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem;
}

.table thead th {
  font-weight: 700 !important;
  color: #000000 !important;
  font-size: 14px !important;
}
.table tbody tr {
  font-weight: 400 !important;
  color: #000000 !important;
  font-size: 14px !important;
}
.link-image {
  width: 44.88px;
  height: 43.52px;
  padding-right: 0;
  border-radius: 8px;
  object-fit: cover;
}

.table-header-area-main {
  background-color: #d4dde4;
  /* background-color: #f4f4f4; */
}

.table-header-area {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
